module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-container journal-container"
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "journal-list listing",
    class: {
      'images-loaded': _vm.imgsLoaded
    }
  }, _vm._l((_vm.slides), function(slide, si) {
    return _c('article', {
      key: slide.nid,
      staticClass: "journal-entry",
      attrs: {
        "data-index": si,
        "data-path": slide.path
      },
      on: {
        "mouseover": function($event) {
          _vm.updateCurrId(slide.nid)
        }
      }
    }, [(slide.hasSingleImage) ? _c('figure', {
      staticClass: "half-width float-first"
    }, [_c('img', {
      attrs: {
        "src": slide.image.sizes[_vm.defaultSize],
        "width": slide.image.attributes.width,
        "height": slide.image.attributes.height
      }
    }), _vm._v(" "), (slide.image.attributes) ? _c('figcaption', [_c('div', {
      staticClass: "inner"
    }, [_vm._v("\n            " + _vm._s(slide.image.attributes.title) + "\n          ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "core-content half-width float-second"
    }, [_c('h4', {
      staticClass: "blog-title"
    }, [_vm._v(_vm._s(slide.title))]), _vm._v(" "), _c('time', {
      staticClass: "date",
      attrs: {
        "title": slide.date
      }
    }, [_vm._v(_vm._s(_vm._f("toYear")(slide.date)))]), _vm._v(" "), _c('div', {
      staticClass: "body",
      domProps: {
        "innerHTML": _vm._s(slide.body)
      }
    })])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b2c4556"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Journal.vue
// module id = 45
// module chunks = 0